<div class="tl-dialog">

  <!-- Header -->
  <div class="tl-header">
    <div class="tl-title-wrap">
      <div class="tl-title-icon">
        <mat-icon>content_copy</mat-icon>
      </div>
      <div class="tl-title-text">
        <h2 class="tl-title">Copy task library items</h2>
        <div class="tl-subtitle">Copy items from this library to your other companies</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="tl-close" [disabled]="saveClicked" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <form id="taskLibraryMigrate" class="tl-body" (ngSubmit)="moveClick()">

    <div class="tl-field">
      <div class="tl-label-row">
        <label class="tl-label">Task library items <span class="tl-req">*</span></label>
        <span class="tl-count" [class.on]="selectedTaskCount > 0">{{selectedTaskCount}} selected</span>
      </div>
      <mat-form-field appearance="outline" class="tl-mat full-width">
        <mat-select [formControl]="selectedTasks" multiple placeholder="Select task library items">
          <mat-option>
            <ngx-mat-select-search [formControl]="taskFilterCtrl"
              placeholderLabel="Find tasks..."
            noEntriesFoundLabel="no matching task found"></ngx-mat-select-search>
          </mat-option>
          <mat-option disabled="disabled" class="filter-option">
            <button mat-raised-button class="mat-primary fill text-sm" (click)="selectAll()">
              Select All
            </button>
            <button mat-raised-button class="mat-accent fill text-sm" style="margin-left: 10px;" (click)="change([])">
              Deselect All
            </button>
          </mat-option>
          <mat-select-trigger>
            @if (selectedTasks.value?.[0] == null) {
              None Selected
            }
            @if (selectedTasks.value?.[0] != null) {
              {{selectedTasks.value?.[0].name || ''}}
              @if ((selectedTasks.value?.length || 0) > 1) {
                <span class="example-additional-selection">
                  (+{{(selectedTasks.value?.length || 0) - 1}} {{selectedTasks.value?.length === 2 ? 'other' :
                  'others'}})
                </span>
              }
            }
          </mat-select-trigger>
          @for (templatedTask of filteredTemplatedTasks | async; track templatedTask) {
            <mat-option [value]="templatedTask">
              {{templatedTask.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="tl-field tl-field-last">
      <div class="tl-label-row">
        <label class="tl-label">Copy to companies <span class="tl-req">*</span></label>
        <span class="tl-count" [class.on]="otherCompanies.length > 0">{{otherCompanies.length}} selected</span>
      </div>
      <app-company-select-multiple
        class="tl-picker"
        [companyIdsToExclude]="companyIdsToExclude"
        [(selectedCompanies)]="otherCompanies"
      ></app-company-select-multiple>
    </div>

  </form>

  <!-- Footer -->
  <div class="tl-footer">
    <span class="tl-footer-note">
      <mat-icon>info_outline</mat-icon>
      Items are copied — the originals stay in this library.
    </span>
    <div class="tl-footer-actions">
      <button mat-button mat-dialog-close class="tl-btn-ghost" [disabled]="saveClicked">Cancel</button>
      <button id="task_library_migrate_save" type="submit" form="taskLibraryMigrate" class="tl-btn-primary"
        [disabled]="saveClicked || selectedTaskCount === 0 || otherCompanies.length === 0">
        @if (saveClicked) {
          <mat-spinner diameter=20 strokeWidth=3></mat-spinner>
        } @else {
          <span>Copy items</span>
          <mat-icon>check</mat-icon>
        }
      </button>
    </div>
  </div>

</div>
